import React, { useState } from 'react';
import { Card, Spinner } from 'ui';
import useFetch from 'components/shared/hooks/useFetch';
import Pagination from 'components/shared/pagination';
import { BlankSlate } from 'components/_shared/blank_slate';
import { routes } from 'constants/config';
import DateFormat from 'constants/date_format';
import { setQueryString } from 'utils/url';

const formatDate = date => moment(date).format(DateFormat.LONG_AT_TIME);

const AttemptsContainer = ({ scenarioId, groupId }) => {
  const [page, setPage] = useState(1);
  const attemptUrl = setQueryString(
    routes.ON_DEMAND_PRACTICE.CREATOR.ATTEMPTS.INDEX(scenarioId),
    { page, group_id: groupId },
  );
  const { data, initialLoading } = useFetch(attemptUrl);

  return (
    <div>
      {initialLoading && <Spinner />}
      {!initialLoading && (
        <Card className="bs-n">
          <Card.Content>
            {data.attempts.length === 0 && (
              <BlankSlate align="left" className="fz-lg">
                {t(
                  'practice.on_demand_practice.overview.attempts_table.blank_slate_message',
                )}
              </BlankSlate>
            )}
            {data.attempts.length > 0 && (
              <table
                className="DataTable Table tablesaw tablesaw-stack w-fill"
                data-tablesaw-mode="stack"
              >
                <thead>
                  <tr>
                    <th name="userName" className="DataTable-name">
                      <span className="pl-16">
                        {t(
                          'practice.on_demand_practice.overview.attempts_table.name_header',
                        )}
                      </span>
                    </th>
                    <th name="lastCompletedAt">
                      <span className="pl-16">
                        {t(
                          'practice.on_demand_practice.overview.attempts_table.last_completed_header',
                        )}
                      </span>
                    </th>
                    <th name="count">
                      <span className="pl-16">
                        {t(
                          'practice.on_demand_practice.overview.attempts_table.count_header',
                        )}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.attempts.map(attempt => (
                    <tr key={attempt.id}>
                      <td className="DataTable-name">
                        <a
                          href={routes.ON_DEMAND_PRACTICE.CREATOR.ATTEMPTS.USER(
                            scenarioId,
                            attempt.id,
                          )}
                          className="pl-16 d-b"
                        >
                          {attempt.userName}
                        </a>
                      </td>
                      <td>
                        <time className="pl-16">
                          {formatDate(attempt.lastCompletedAt)}
                        </time>
                      </td>
                      <td>
                        <span className="pl-16">{attempt.count}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card.Content>
          {data.pagination.pages > 1 && (
            <Pagination
              pages={data.pagination.pages}
              selected={data.pagination.selected}
              pageSelectCallback={setPage}
              customClass="h-100 ml-16 py-8"
            />
          )}
        </Card>
      )}
    </div>
  );
};

export default AttemptsContainer;
